<template>
    <div>
      <Pos_supplier_add/>
    </div>
  </template>
  
  <script>
  import Pos_supplier_add from "@/components/adminArin/pos_system/product/Pos_supplier_add";
  export default {
    name: "PosSupplierAdd",
    components: {
        Pos_supplier_add
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  